import { render, staticRenderFns } from "./fieldVideoUpload.vue?vue&type=template&id=c2760f08&scoped=true"
import script from "./fieldVideoUpload.vue?vue&type=script&lang=js"
export * from "./fieldVideoUpload.vue?vue&type=script&lang=js"
import style0 from "./fieldVideoUpload.vue?vue&type=style&index=0&id=c2760f08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2760f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2760f08')) {
      api.createRecord('c2760f08', component.options)
    } else {
      api.reload('c2760f08', component.options)
    }
    module.hot.accept("./fieldVideoUpload.vue?vue&type=template&id=c2760f08&scoped=true", function () {
      api.rerender('c2760f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldVideoUpload.vue"
export default component.exports